<template>
  <div class="manner_box">
    <h3 class="activeR">我的购买</h3>
    <div style="overflow-y: hidden">
      <div
        class="information_box"
        v-infinite-scroll="load"
        style="overflow: auto"
      >
        <el-card
          v-for="(item, index) in release_notes_l"
          :key="index"
          class="cuP"
          @click="fnRead(item.note_id)"
        >
          <span
            class="icon_mm"
            v-if="item.first_choice >= 0 && 'first_choice' in item"
          >
            <svg
              v-if="
                item.match_state == -1 &&
                (item.first_result == 1 || item.two_result == 1)
              "
              class="icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-hit"></use>
            </svg>
            <svg
              v-else-if="
                item.match_state !== -1 &&
                !item.first_result &&
                !item.two_result
              "
              class="icon"
              aria-hidden="true"
            >
              <use
                xlink:href="#icon-weikaishi2
"
              ></use>
            </svg>
            <svg
              v-else-if="item.match_state == -1"
              class="icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-weimingzhong"></use>
            </svg>
          </span>
          <h6>
            <span
              >[{{ item.sclass_name }}] {{ item.home_team_name }}
              <b>{{
                item.match_state === -1
                  ? item.home_score + "-" + item.guest_score
                  : $filters.match_state(item.match_state)
              }}</b>
              {{ item.guest_team_name }}</span
            >
          </h6>
          <div class="img_tit">
            <div class="picture_Luck">
              <img
                :src="`http://oss.deyity.com/img/user_photo/${item.user_photo}`"
              />
              <el-link type="primary" :underline="false" class="uesr_name">
                {{ item.uesr_name }}</el-link
              >
            </div>
            <div class="tit cuP">
              <b
                class="activeR"
                v-if="item.first_choice >= 0 && 'first_choice' in item"
                >{{
                  item.two_choice == null
                    ? item.note_type == 1
                      ? `单选:${choice_type[item.first_choice]}`
                      : item.note_type == 2
                      ? `单选:(${
                          item.goal > 0 ? `+${item.goal}` : item.goal
                        })主${choice_type[item.first_choice]}`
                      : item.note_type == 3
                      ? `单选:(${item.goal})${
                          item.first_choice == 3 ? "大球" : "小球"
                        }`
                      : ""
                    : `首选:${
                        choice_type[item.first_choice]
                      }&nbsp;&nbsp;&nbsp;`
                }}{{
                  item.two_choice != null
                    ? `次选:${choice_type[item.two_choice]}`
                    : ""
                }}</b
              >
              <div class="content">
                {{ item.content }}
              </div>
              <p class="pp">
                <span>{{ item.public_time }}</span>
                <span class="activeR cuP">已支付(￥{{ item.price }})</span>
              </p>
            </div>
          </div>
        </el-card>
        <p v-if="loading" class="loading">加载中...</p>
        <p v-if="noMore" class="loading">没有更多了</p>
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, ref } from "vue";
import "../../../assets/font/iconfont";
import { useRouter } from "vue-router";
export default {
  props: ["AUTH_OBJ", "token"],
  setup() {
    let router = useRouter();
    let { proxy: _this } = getCurrentInstance();
    // 笔记列表
    let loading = ref(true);
    let noMore = ref(false);
    let release_notes_l = ref([]);
    let pages = ref(1);
    let release_notes_list = async () => {
      let { data: res } = await _this.$http.get(
        `/auth/user/paid_notes_list`,
        {
          params: { page: pages.value },
        }
        // ${props.AUTH_OBJ.user_id}
      );
      console.log(res.data);
      if (res.data.length === 0) {
        loading.value = false;
        noMore.value = true;
        _this.$notify({
          title: "提示",
          message: "已加载全部内容",
          type: "error",
        });
      }
      release_notes_l.value = release_notes_l.value.concat(
        ...JSON.parse(JSON.stringify(res.data))
      );
    };
    // 无限滚动
    const load = () => {
      release_notes_list();
      pages.value++;
    };
    // 跳转
    let fnRead = (note_ids) => {
      // 直接阅读
      let routeUrl = router.resolve({
        path: `/note_details/${note_ids}`,
      });
      window.open(routeUrl.href, "_blank");
    };
    // load()
    return {
      release_notes_l,
      load,
      loading,
      noMore,
      choice_type: {
        3: "胜",
        1: "平",
        0: "负",
      },
      fnRead,
    };
  },
};
</script>
<style scoped lang="less">
.manner_box {
  h3 {
    margin-bottom: 10px;
    font-weight: 600;
  }
  b {
    color: #000;
    font-size: 14px !important;
  }
  .el-card {
    position: relative;
    margin-bottom: 10px;
    .icon_mm {
      position: absolute;
      right: 10px;
      top: -30px;
      .icon {
        width: 80px;
      }
    }
    h6 {
      font-weight: 600;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 0 10px 0;
      .xz {
        font-size: 14px;
        padding: 2px 6px;
        background: red;
        border-radius: 4px;
        color: #fff;
      }
      .activeH5 {
        background: #606266;
      }
    }
    .img_tit {
      display: flex;
      justify-content: space-between;
    }

    .picture_Luck {
      width: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 40px;
        border-radius: 50%;
      }
      .uesr_name {
        text-align: center;
        // width: 80px;
        display: -webkit-box; /*将对象转为弹性盒模型展示*/
        -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
        -webkit-line-clamp: 1; /*限制文本行数*/
        overflow: hidden;
      }
      .Luck_box {
        .Luck_t {
          // width: 100%;
          // height: 20px;
          padding: 2px 10px;
          font-size: 12px;
          border-radius: 10px;
          background-color: #f56c6c;
          color: #eee;
        }
      }
    }
    .tit {
      width: 90%;
      &:hover .content {
        color: #409eff;
      }
      h6 {
        font-weight: 600;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0 10px 0;
        .xz {
          font-size: 14px;
          padding: 2px 6px;
          background: #409eff;
          border-radius: 4px;
          color: #fff;
        }
      }
      .activeH {
        // margin: 10px;
      }
      .content {
        background: #eee;
        padding: 10px;
        font-size: 14px;
        border-radius: 10px;
        margin: 10px 0;
      }
      .pp {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #8c8c8c;
        font-weight: 600;
        .pp_span {
          span {
            margin: 0 10px;
          }
        }
      }
    }
  }
}
.information_box::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}
.information_box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.information_box::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.information_box {
  height: 600px;
}
.loading {
  color: #8c8c8c;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
</style>
